export default "__VITE_ASSET__Djq6AIkF__$_?nuxt_component=async&nuxt_component_name=SvgoSecuritasTextLogo&nuxt_component_export=default__"